import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

export const useStyles = ({
  custom: {
    palette: { colorSupportSteel },
  },
  spacing: { unit },
}: Theme) =>
  createStyles({
    fade: {
      maxHeight: 384,
      minWidth: 400,
      overflowY: 'auto',
    },
    iconButton: {
      display: 'inline-block',
      float: 'right',
      margin: `${unit}px 0px`,
    },
    iconButtonWhite: {
      color: 'white',
    },
    progressWrapper: {
      display: 'flex',
      justifyContent: 'center',
      padding: unit * 2,
    },
    tooltip: {
      backgroundColor: `${colorSupportSteel} !important`,
      fontWeight: 500,
      textAlign: 'center',
    },
    wrapper: {
      display: 'grid',
      placeItems: 'center',
      padding: unit * 2,
    },
    goToFormBuilder: {
      width: '50%',
    },
  });
